"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _react = _interopRequireDefault(require("react"));
var _DialogWrap = _interopRequireDefault(require("./base/DialogWrap"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledModal = require("./StyledModal");
var _ykbUtils = require("ykb-utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _reactDom = require("react-dom");
var _ModalContext = require("./context/ModalContext");
var _Globals = _interopRequireDefault(require("../ykb-styled-components/Globals"));
var _excluded = ["title", "footer", "children", "visible", "onClose", "className", "closable", "destroyOnClose", "maskClosable", "size", "height", "prefixCls", "type", "centered", "getTarget", "getContainer", "renderOnBody", "afterClose", "onlyActiveTab", "isVerticalCenter", "allowOverflow"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint no-console:0 */
var CloseIcon = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "close",
  size: 24
});

// Alternatif çözüm üretilebilirse geri eklenebilir.
// const createShadow = (parent, mountEl, styleEl) => {
//   mountEl.classList.add('renderOnBody');

//   document.body.appendChild(parent);

//   const shadowRoot = parent.attachShadow({ mode: 'open' });

//   Object.defineProperty(mountEl, 'ownerDocument', {
//     value: shadowRoot,
//   });

//   shadowRoot.createElement = (...args) => document.createElement(...args);
//   shadowRoot.createElementNS = (...args) => document.createElementNS(...args);
//   shadowRoot.createTextNode = (...args) => document.createTextNode(...args);
//   shadowRoot.defaultView = shadowRoot.defaultView ? shadowRoot.defaultView : {};

//   shadowRoot.defaultView['getComputedStyle'] = (...args) =>
//     window.getComputedStyle(...args);

//   shadowRoot.appendChild(mountEl);
//   shadowRoot.appendChild(styleEl);
// };

var registerRenderOnBody = function registerRenderOnBody() {
  var WebComponentWrapper = /*#__PURE__*/function (_HTMLElement) {
    function WebComponentWrapper() {
      (0, _classCallCheck2.default)(this, WebComponentWrapper);
      return _callSuper(this, WebComponentWrapper, arguments);
    }
    (0, _inherits2.default)(WebComponentWrapper, _HTMLElement);
    return (0, _createClass2.default)(WebComponentWrapper);
  }(/*#__PURE__*/(0, _wrapNativeSuper2.default)(HTMLElement));
  customElements.get('render-on-body') || customElements.define('render-on-body', WebComponentWrapper);
};
var Modal = /*#__PURE__*/function (_React$Component) {
  function Modal(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    (0, _defineProperty2.default)(_this, "state", {
      visible: false,
      destroyOnClose: false
    });
    (0, _defineProperty2.default)(_this, "onDestroyOnCloseChange", function (e) {
      _this.setState({
        destroyOnClose: e.target.checked
      });
    });
    _this.mainContainer = document.querySelector('#page-container .tab-pane.active .hmn-tab-content-wrapper');
    if (_this.props.renderOnBody) {
      if (!_this.props.getBodyContainer && !_this.props.getBodyTarget) {
        registerRenderOnBody();
        _this.bodyParent = document.createElement('render-on-body');
        _this.bodyContainer = document.createElement('div');
        _this.bodyContainer.classList.add('renderOnBody');
        _this.bodyTarget = document.createElement('div');

        // createShadow(this.bodyParent, this.bodyContainer, this.bodyTarget);
        _this.bodyParent.appendChild(_this.bodyTarget);
        _this.bodyParent.appendChild(_this.bodyContainer);
        document.body.appendChild(_this.bodyParent);
      }
      _this.handleBodyContainer = _this.handleBodyContainer.bind(_this);
      _this.handleBodyTarget = _this.handleBodyTarget.bind(_this);
      _this.handleBodyStyle = _this.handleBodyStyle.bind(_this);
      _this.getHmnContentWrapper = _this.getHmnContentWrapper.bind(_this);
      _this.isUseOnlyActiveTab = _this.isUseOnlyActiveTab.bind(_this);
      _this.maskRenderTabContentWrapper = _this.maskRenderTabContentWrapper.bind(_this);
      _this.removeMaskRenderTabContentWrapper = _this.removeMaskRenderTabContentWrapper.bind(_this);
      _this.handleOnClose = _this.handleOnClose.bind(_this);
    }
    return _this;
  }
  (0, _inherits2.default)(Modal, _React$Component);
  return (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = (0, _reactDom.findDOMNode)(this);
      this.handleBodyStyle();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleBodyStyle();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.renderOnBody) {
        var _this$bodyParent;
        (_this$bodyParent = this.bodyParent) === null || _this$bodyParent === void 0 ? void 0 : _this$bodyParent.remove();
      }
      if (this.isUseOnlyActiveTab()) {
        this.removeMaskRenderTabContentWrapper();
      }
    }
  }, {
    key: "handleOnClose",
    value: function handleOnClose(e) {
      var onClose = this.props.onClose;
      if (typeof onClose === 'function') onClose(e);
      if (this.isUseOnlyActiveTab()) {
        this.removeMaskRenderTabContentWrapper();
      }
    }
  }, {
    key: "handleBodyContainer",
    value: function handleBodyContainer() {
      var customContainer = this.props.getBodyContainer;
      if (typeof customContainer === 'function') {
        return customContainer();
      }
      return this.bodyContainer;
    }
  }, {
    key: "handleBodyTarget",
    value: function handleBodyTarget() {
      var customTarget = this.props.getBodyTarget;
      if (typeof customTarget === 'function') {
        return customTarget();
      }
      return this.bodyTarget;
    }
  }, {
    key: "handleBodyStyle",
    value: function handleBodyStyle() {
      if (this.props.renderOnBody) {
        var _this$bodyParent2;
        (_this$bodyParent2 = this.bodyParent) === null || _this$bodyParent2 === void 0 ? void 0 : _this$bodyParent2.classList.toggle('active', this.props.visible);
      }
    }
  }, {
    key: "getHmnContentWrapper",
    value: function getHmnContentWrapper() {
      return this.mainContainer;
    }
  }, {
    key: "getModalMaskAll",
    value: function getModalMaskAll() {
      return this.getHmnContentWrapper().querySelectorAll('#modal-mask') || [];
    }
  }, {
    key: "isUseOnlyActiveTab",
    value: function isUseOnlyActiveTab() {
      return this.props.onlyActiveTab && this.getHmnContentWrapper() !== null;
    }
  }, {
    key: "maskRenderTabContentWrapper",
    value: function maskRenderTabContentWrapper() {
      var _this$getHmnContentWr;
      var maskList = this.getModalMaskAll();
      if (maskList.length > 0) return;
      var newDiv = document.createElement('div');
      newDiv.setAttribute('id', 'modal-mask');
      newDiv.setAttribute('style', 'inset: 0px; background-color: rgba(55, 55, 55, 0.6); height: 100%; z-index: 999; position: absolute;');
      (_this$getHmnContentWr = this.getHmnContentWrapper()) === null || _this$getHmnContentWr === void 0 ? void 0 : _this$getHmnContentWr.append(newDiv);
    }
  }, {
    key: "removeMaskRenderTabContentWrapper",
    value: function removeMaskRenderTabContentWrapper() {
      var modalMaskAll = this.getModalMaskAll();
      for (var i = 0; i < modalMaskAll.length; i++) {
        var modalMask = modalMaskAll[i];
        modalMask === null || modalMask === void 0 ? void 0 : modalMask.remove();
      }
    }
  }, {
    key: "setPanelClass",
    value: function setPanelClass() {
      this.panelClass = '';
      if (this.props.pageCentered) {
        if (window.sidePanelsExpanded) {
          // Sparx'ta panel açıksa
          this.panelClass = 'page-centered';
        } else if (window.isCallCenterApplication) {
          if (this.bodyClassController('wide-screen')) {
            this.panelClass = 'page-centered-hmn-cc-half';
          } else {
            this.panelClass = 'page-centered-hmn-cc-full';
          }
        } else if (typeof window.isSparxMode == 'function' && !window.isSparxMode()) {
          if (this.bodyClassController('wide-screen') && !this.bodyClassController('wide-content-area') || !this.bodyClassController('wide-screen') && this.bodyClassController('wide-content-area')) {
            // Harmoni'de menü veya müşteri paneli açıksa
            this.panelClass = 'page-centered-hmn-half';
          } else if (!this.bodyClassController('wide-screen') && !this.bodyClassController('wide-content-area')) {
            // Harmoni'de menü ve müşteri paneli açıksa
            this.panelClass = 'page-centered-hmn-full';
          }
        }
      }
    }
  }, {
    key: "bodyClassController",
    value: function bodyClassController(keyword) {
      return document.body.classList.contains(keyword);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        title = _this$props.title,
        footer = _this$props.footer,
        children = _this$props.children,
        visible = _this$props.visible,
        onClose = _this$props.onClose,
        className = _this$props.className,
        closable = _this$props.closable,
        destroyOnClose = _this$props.destroyOnClose,
        maskClosable = _this$props.maskClosable,
        size = _this$props.size,
        height = _this$props.height,
        prefixCls = _this$props.prefixCls,
        type = _this$props.type,
        centered = _this$props.centered,
        _this$props$getTarget = _this$props.getTarget,
        getTarget = _this$props$getTarget === void 0 ? _ykbUtils.containerChecker : _this$props$getTarget,
        _this$props$getContai = _this$props.getContainer,
        _getContainer = _this$props$getContai === void 0 ? _ykbUtils.containerChecker : _this$props$getContai,
        renderOnBody = _this$props.renderOnBody,
        afterClose = _this$props.afterClose,
        onlyActiveTab = _this$props.onlyActiveTab,
        isVerticalCenter = _this$props.isVerticalCenter,
        allowOverflow = _this$props.allowOverflow,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      this.setPanelClass();
      function PromptIcon() {
        switch (type) {
          case 'success':
            return /*#__PURE__*/_react.default.createElement(_Icon.default, {
              name: "check-circle",
              colorType: "success",
              size: "64",
              style: {
                marginBottom: '10px'
              }
            });
          case 'info':
            return /*#__PURE__*/_react.default.createElement(_Icon.default, {
              name: "info-circle",
              colorType: "primary",
              size: "64",
              style: {
                marginBottom: '10px'
              }
            });
          case 'warning':
            return /*#__PURE__*/_react.default.createElement(_Icon.default, {
              name: "warning-circle",
              colorType: "warning",
              size: "64",
              style: {
                marginBottom: '10px'
              }
            });
          case 'error':
            return /*#__PURE__*/_react.default.createElement(_Icon.default, {
              name: "close-circle",
              colorType: "danger",
              size: "64",
              style: {
                marginBottom: '10px'
              }
            });
          default:
            return null;
        }
      }
      var useOnlyActiveTab = this.isUseOnlyActiveTab();
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_ModalContext.ModalProvider, {
          renderOnBody: renderOnBody,
          container: _this2.handleBodyContainer()
        }, /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.StyleSheetManager, {
          target: renderOnBody ? _this2.handleBodyTarget() : getTarget(_this2.node)
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderOnBody && /*#__PURE__*/_react.default.createElement(_Globals.default, {
          theme: theme
        }), /*#__PURE__*/_react.default.createElement(_StyledModal.StyledModal, {
          prefixCls: prefixCls,
          theme: theme,
          size: size,
          height: height,
          type: type,
          closable: closable,
          title: title,
          onlyActiveTab: useOnlyActiveTab,
          centered: centered,
          isVerticalCenter: isVerticalCenter
        }, function (styledPrefix) {
          var cls = (0, _classnames2.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(styledPrefix, "--xsmall"), !centered && size === 'xsmall'), "".concat(styledPrefix, "--small"), !centered && size === 'small'), "".concat(styledPrefix, "--default"), !centered && size === 'default'), "".concat(styledPrefix, "--large"), !centered && size === 'large'), "".concat(styledPrefix, "--xlarge"), !centered && size === 'xlarge'), "".concat(styledPrefix, "--maximum"), !centered && size === 'maximum'), "".concat(styledPrefix, "--center"), centered), "".concat(styledPrefix, "--noheader"), !title), "".concat(styledPrefix, "--").concat(_this2.panelClass), _this2.panelClass), "".concat(styledPrefix, "--custom-height"), height));
          var header;
          if (title) {
            header = /*#__PURE__*/_react.default.createElement("div", {
              className: "".concat(styledPrefix, "-title")
            }, title);
          }

          // active tab var ise document üzerinden mask elementi alınır ve dialog içerisindeki mask elementi gizlenir.
          if (useOnlyActiveTab) {
            if (visible) _this2.maskRenderTabContentWrapper();else _this2.removeMaskRenderTabContentWrapper();
          }
          if (visible || !destroyOnClose) {
            return /*#__PURE__*/_react.default.createElement(_DialogWrap.default, (0, _extends2.default)({
              visible: visible,
              onClose: function onClose(e) {
                return _this2.handleOnClose(e);
              },
              title: /*#__PURE__*/_react.default.createElement("div", null, title),
              footer: footer,
              className: cls,
              animation: "zoom",
              maskAnimation: "fade",
              prefixCls: styledPrefix,
              closable: closable,
              maskClosable: maskClosable,
              onlyActiveTab: useOnlyActiveTab // dialog içerisinde kullanılan getMaskElement gizlenir ve yerine sadece aktif tabın mask elementi custom olarak eklenir.
              ,
              getContainer: function getContainer() {
                return renderOnBody ? _this2.handleBodyContainer() : _getContainer(_this2.node);
              },
              closeIcon: CloseIcon,
              size: size,
              centered: centered,
              afterClose: afterClose,
              allowOverflow: allowOverflow
            }, rest), /*#__PURE__*/_react.default.createElement(PromptIcon, null), centered && header, /*#__PURE__*/_react.default.createElement("div", {
              className: "".concat(styledPrefix, "-children-wrapper")
            }, children));
          }
          return null;
        }))));
      }));
    }
  }]);
}(_react.default.Component);
Modal.propTypes = {
  visible: _propTypes.default.bool,
  title: _propTypes.default.string,
  destroyOnClose: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['xsmall', 'small', 'default', 'large', 'xlarge', 'maximum']),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  closable: _propTypes.default.bool,
  maskClosable: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  className: _propTypes.default.string,
  footer: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefixCls: _propTypes.default.string,
  type: _propTypes.default.oneOf(['success', 'info', 'warning', 'error', '']),
  getContainer: _propTypes.default.func,
  /**
   * Centered prop aligns the content to the center. The centered modal has a specific size, so its size cannot be changed when passing the centered prop.
   */
  centered: _propTypes.default.bool,
  renderOnBody: _propTypes.default.bool,
  afterClose: _propTypes.default.func,
  onlyActiveTab: _propTypes.default.bool,
  isVerticalCenter: _propTypes.default.bool,
  alignContentVertically: _propTypes.default.bool,
  /**
   * Enabling overflow when dragging to see content in the page.
   */
  allowOverflow: _propTypes.default.bool,
  /**
   * Use this prop to horizontally align Modal or Message when side panels expanded in Sparx.
   */
  pageCentered: _propTypes.default.bool
};
Modal.defaultProps = {
  visible: false,
  destroyOnClose: false,
  size: 'default',
  maskClosable: false,
  closable: true,
  onClose: function onClose(noop) {
    return noop;
  },
  className: '',
  type: '',
  centered: false,
  renderOnBody: false,
  isVerticalCenter: false,
  alignContentVertically: true,
  allowOverflow: false,
  pageCentered: false
};
var _default = exports.default = Modal;